module.exports = __webpack_public_path__ + "img/24.01724ca5.png";